import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-form-question-icon-index',
    template: `
        <div class="form-field-question-index-icon-wrapper">
            <mat-icon class="question-icon BrandedColor" [ngClass]="iconClassName" />
            {{ questionIndex }}
        </div>
    `,
    styleUrls: ['./form-question-icon-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-question-icon-index' },
    standalone: false,
})
export class FormQuestionIconIndexComponent {
    @Input({ required: true }) iconClassName: string;
    @Input({ required: true }) questionIndex: number;
}
